import React, { useState, useEffect } from 'react';
import RealProjectsThumb from './RealProjectsThumb'
import SideProjects from './SideProjects'
import Footer from './Footer'
import { Button } from '@/components/ui/button'
import { Download, FileText, FileTextIcon } from 'lucide-react'
import { TextScramble } from '@/components/motion-primitives/text-scramble'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { TbFileTypeJsx } from "react-icons/tb";
import { PiFilePdf } from "react-icons/pi";
import { ModeToggle } from '@/components/mode-toggle'
import Domiciline from './utils/Domiciline'
import { Helmet } from 'react-helmet'
import Navigationbar from './utils/Navigationbar'
import { NavLink } from 'react-router-dom'
import { Toaster } from '@/components/ui/sonner'
import RealProjectsThumbSm from './RealProjectsThumbSm'
import SideProjectsSm from './SideProjectsSm'

export default function Craft() {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

    useEffect(() => {
    const handleResize = () => {
        setIsMobile(window.innerWidth < 640); // Adjust breakpoint as needed
    };

    window.addEventListener('resize', handleResize);

    return () => {
        window.removeEventListener('resize', handleResize);
    };
    }, []);


//       const generateRandomString = (length) => {
//     const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
//     return Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
//   };

  // Generate 300 string acak
//   const randomParagraphs = Array.from({ length: 3800 }, (_, i) => (
//     <p key={i} className="text-sm hover:opacity-80">
//       {generateRandomString(1)} {/* ganti 8 kalau mau string lebih panjang */}
//     </p>
//   ));

  return (
    <div className='relative'>
        
        <section className='w-full'>
            <div className='container max-w-md mx-auto px-6 lg:px-0'>
                <div className='relative z-50 w-full'>
                    {/* <div className='mb-4 flex items-center justify-between gap-4'>
                        <NavLink to='/'>
                            <img src='/unaascii-xsm.png' className='w-12 block dark:hidden rounded-full' />
                            <img src='/unaascii-xsm-white.png' className='w-12 hidden dark:block rounded-full' />
                        </NavLink>
                        <Navigationbar />
                    </div> */}
                    <div className='flex flex-col gap-6 mb-6'>
                        {/* <div className='flex flex-col items-start justify-center mb-8'>
                            <p>Dinivan Nendra</p>
                            <p className='opacity-60 text-sm font-light'>UIX Designer & Engineer</p>
                        </div> */}
                        <div className='flex flex-col items-start justify-start gap-4'>
                            <p className='opacity-50'>I've teamed up with great collaborators on all kinds of projects — open-source work, complex platforms, everything in between. <br /> If you've got something brewing, I'd love to hear about it.</p>
                        </div>
                    </div>
                </div>
            </div>
            {isMobile ? 
            <div className='mt-16'>
                <RealProjectsThumbSm />
                <SideProjectsSm />
            </div> : 
            <div className='mt-20'>
                <RealProjectsThumb />
                <SideProjects />
            </div>}    
            
            
            {/* <div className='flex items-center w-full justify-between gap-3 pt-4 pb-8 container max-w-md mx-auto'>
                        <Footer />
                        <ModeToggle />
                    </div> */}
            <Toaster />
        </section>

        {isMobile ? 
         <div/>
         : <div className='absolute top-0 opacity-[.07] dark:opacity-[.05] min-w-screen flex flex-wrap gap-2'>
            {/* {randomParagraphs} */}
        </div>
        }
    </div>
  )
}
